import React, { useContext } from 'react'
import Tooltip from '@mui/material/Tooltip'

import useI18n from 'hooks/useI18n'
import { CoreContext } from 'context/CoreContext'
import {
  AUDIENCE_ACCESS_DEFINITIONS,
  canViewAudienceAccessIndicators,
  normalizeAudienceAccess,
} from 'utils/audienceAccess'
import { AudienceIcon, AudienceIndicator, AudienceIndicators } from './styled'

export default function AudienceAccessIndicators({
  audiences = [],
  belowFavorite,
  belowTopMeta,
  inline,
  user: userOverride,
}) {
  const { user } = useContext(CoreContext)
  const { t } = useI18n()
  const normalizedAudiences = normalizeAudienceAccess(audiences)

  return !canViewAudienceAccessIndicators(userOverride || user) || !normalizedAudiences.length ? null : (
    <AudienceIndicators
      role="group"
      aria-label={t('audience_access_available_audiences')}
      belowFavorite={belowFavorite}
      belowTopMeta={belowTopMeta}
      inline={inline}
    >
      {normalizedAudiences.map((audience) => (
        <Tooltip
          arrow
          enterTouchDelay={0}
          key={audience}
          leaveTouchDelay={2500}
          title={t(AUDIENCE_ACCESS_DEFINITIONS[audience].labelKey)}
        >
          <AudienceIndicator
            role="img"
            tabIndex={0}
            aria-label={t(AUDIENCE_ACCESS_DEFINITIONS[audience].labelKey)}
            onClick={(event) => event.stopPropagation()}
            onKeyDown={(event) => event.stopPropagation()}
          >
            <AudienceIcon
              icon={AUDIENCE_ACCESS_DEFINITIONS[audience].icon}
              alt=""
              aria-hidden="true"
            />
          </AudienceIndicator>
        </Tooltip>
      ))}
    </AudienceIndicators>
  )
}
